<style lang="less">
@import "./main.less";
</style>
<style lang="less" scoped>
  .changeTenant{
    position: absolute;
    top: 61px;
    margin-left: 10px;
    cursor: pointer;
    left: 160px;
    font-size: 14px;
    color: #fff;
    background-image: url("../images/switchTenantsIcon.svg");
    width: 14px;
    height: 14px;

    &:hover{
      background-image: url("../images/activeSwitchTenantsIcon.svg");
    }
  }
  .tenantListBox{
    max-height: 300px;
    overflow: auto;
    min-height: 50px;
  }
</style>
<template>
  <div class="main" :class="{ 'main-hide-text': shrink }">
    <div class="sidebar-menu-con" :style="{ width: shrink ? '67px' : '200px' }">
      <!--<scroll-bar ref="scrollBar">-->
      <shrinkable-menu
        :shrink="shrink"
        @on-change="handleSubmenuChange"
        :theme="menuTheme"
        :before-push="beforePush"
        :open-names="openedSubmenuArr"
        :menu-list="menuList"
        :tenantName="tenantName"
      >
        <div slot="top" class="logo-con">
          <img v-show="!shrink" src="../images/logo.jpg" key="max-logo" />
          <img
            v-show="shrink"
            src="../images/logo-min.jpg"
            key="min-logo"
            style="max-width:40px;max-height:40px;"
          />
        </div>
      </shrinkable-menu>
      <!--</scroll-bar>-->
    </div>
    <div class="main-header-con" :style="{ paddingLeft: shrink ? '67px' : '200px' }">
      <span v-if="isSuperManager" class="changeTenant" @click="changeTenant">
      </span>
      <div class="main-header">
        <!-- <div class="navicon-con">
                <Button :style="{transform: 'rotateZ(' + (this.shrink ? '-90' : '0') + 'deg)'}" type="text" @click="toggleClick">
                    <Icon type="navicon" size="32"></Icon>
                </Button>
            </div> -->
        <div class="header-avator-con">
          <!-- luzj 更改 -->
          <!-- <full-screen v-model.trim="isFullScreen" @on-change="fullscreenChange"></full-screen>
                <lock-screen></lock-screen>
                <message-tip v-model.trim="mesCount"></message-tip>
                <theme-switch></theme-switch> -->

          <div class="user-dropdown-menu-con">
            <div class="user-dropdown-menu-con-Right" v-if="encryptLevelSwitch">
              <img src="../images/secrecy.png" alt="">
              <div>商密会议系统</div>
            </div>
            <Row
              type="flex"
              justify="end"
              align="middle"
              class="user-dropdown-innercon"
            >
              <Avatar
                :src="avatorPath"
                style="background: #619fe7; margin-left: 10px;margin-right:5px;"
              ></Avatar>
              <Dropdown
                transfer
                trigger="click"
                @on-click="handleClickUserDropdown"
              >
                <a href="javascript:void(0)">
                  <span class="main-user-name">{{ userName }}</span>
                  <Icon type="arrow-down-b" color="#ffffff"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem style="text-align: center;" name="modPWD">修改密码</DropdownItem>
                  <DropdownItem style="text-align: center;" name="loginout" divided>退出登录</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Row>
          </div>
        </div>
      </div>
      <div
        class="tags-con"
        v-show="!controlPage"
        :style="{ paddingLeft: shrink ? '0px' : '0px' }"
      >
        <tags-page-opened :pageTagsList="pageTagsList"></tags-page-opened>
      </div>
    </div>
    <!-- 加载中动画 -->
    <div id="loadBox" class="ivu-modal-mask" v-if="showLoading">
      <div id="loadBoxDiv">
        <Icon type="load-c" size="30" class="demo-spin-icon-load"></Icon>
        <div>{{ showLoadText }}</div>
      </div>
    </div>
    <div
      class="single-page-con"
      :style="{
        left: shrink ? '67px' : '200px',
        top: controlPage ? '60px' : '90px',
      }"
    >
      <div class="header-middle-con">
        <div class="main-breadcrumb">
          <breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav>
        </div>
      </div>
      <div class="single-page">
        <!-- <Spin fix v-if="showLoading">
                <Icon type="load-c" size=24 class="demo-spin-icon-load"></Icon>
                <div style="font-size:16px; ">加载中</div>
            </Spin> -->
        <!-- <Modal :mask-closable="false"
                v-model="showLoading"
                title=""
                :footer-hide = "true"
                >
                <p slot="header" style="display:none;"></p>

            </Modal> -->

        <keep-alive :include="cachePage">
          <router-view v-if="reload"></router-view>
        </keep-alive>
        <footer style="position:absolute;bottom:1rem; text-align:right; left:1rem;right:1rem;color:#ccc; font-size:12px; z-index:-1; text-shadow:1px 1px 0 #fff; ">
          <div>
            <span>系统厂家：杭州席媒科技有限公司　</span>
            <span>电话：0571-88846606　</span>
            <a href="http://www.hzdeskmedia.cn" target="_blank" title="官网" style="color:#ccc;">网址：www.hzdeskmedia.cn</a>
          </div>
        </footer>
      </div>
      <mod-pwd ref="modPwd"></mod-pwd>
    </div>
    <Modal v-model="alertVisible" title="温馨提示" class-name="vertical-center-modal" :closable="false" :mask-closable="false">
        <Alert type="warning" show-icon>
        您暂时没有会议室的查看权限
        <template slot="desc">
          如果需要设置更多权限，请联系管理员！
        </template>
    </Alert>
    <div slot="footer">
          <Button type="primary" @click="ok">确定</Button>
        </div>
    </Modal>
    <Modal 
      v-model="tenantModal"
      title="切换租户"
      width="400"
      :mask-closable="false">
        <div class="tenantListBox">
          <Radio-group v-model="choseValue" style="width: 100%;">
            <Radio style="display: block;margin-bottom: 15px;" :label="item.pkid" v-for="item in tenantList" :key="item.pkid">
              <span>{{ item.name }}</span>
            </Radio>
          </Radio-group>
        </div>
      <div slot="footer">
        <Button type="text" @click="tenantModal = false">取消</Button>
        <Button type="primary" @click="confirmTenant">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import shrinkableMenu from "./main-components/shrinkable-menu/shrinkable-menu.vue";
import tagsPageOpened from "./main-components/tags-page-opened.vue";
import breadcrumbNav from "./main-components/breadcrumb-nav.vue";
import fullScreen from "./main-components/fullscreen.vue";
import lockScreen from "./main-components/lockscreen/lockscreen.vue";
import messageTip from "./main-components/message-tip.vue";
// import themeSwitch from './main-components/theme-switch/theme-switch.vue';
import Cookies from "js-cookie";
import util from "@/libs/util.js";
// import scrollBar from '@/views/my-components/scroll-bar/vue-scroller-bars';
import "@/libs/jquery-1.8.2.min.js";
import "@/libs/jquery-ui.min.js";
import "@/libs/jquery.ui.touch-punch.min.js";
import ModPwd from "./own-space/own-space";

export default {
  components: {
    shrinkableMenu,
    tagsPageOpened,
    breadcrumbNav,
    fullScreen,
    lockScreen,
    messageTip,
    ModPwd,
    // themeSwitch,
    // scrollBar,
    // jquery,
    // jqueryUi
  },
  data() {
    return {
      shrink: false,
      controlPage: false,
      userName: "",
      isFullScreen: false,
      alertVisible:false,
      choseValue:"",          // 租户双向绑定
      tenantModal:false,      // 切换租户弹框
      tenantList:[],          // 租户列表
      isSuperManager:false,   // 是否是管理员    
      tenantName:"无纸化会议后台管理系统",
      // menuTheme:"light"
      minTableWidth: 1600,    // 最小宽度小于1600px时，表格固定操作栏
    };
  },
  computed: {
    encryptLevelSwitch() {
      return this.$store.state.app.encryptLevelSwitch;
    },
    openedSubmenuArr() {
      return this.$store.state.app.openedSubmenuArr;
    },
    showLoading() {
      return this.$store.state.app.showLoading;
    },
    showLoadText() {
      return this.$store.state.app.showLoadText;
    },
    menuList() {
      return this.$store.state.app.menuList;
    },
    pageTagsList() {
      return this.$store.state.app.pageOpenedList; // 打开的页面的页面对象
    },
    currentPath() {
      return this.$store.state.app.currentPath; // 当前面包屑数组
    },
    avatorPath() {
      return localStorage.avatorImgPath;
    },
    cachePage() {
      return this.$store.state.app.cachePage;
    },
    lang() {
      return this.$store.state.app.lang;
    },
    menuTheme() {
      //console.log('this.$store.state.app.menuTheme:', this.$store.state.app.menuTheme);
      return this.$store.state.app.menuTheme;
    },
    mesCount() {
      return this.$store.state.app.messageCount;
    },
    reload() {
      return this.$store.state.app.reload;
    },
    isConnect() {
      console.log(this.$store.state.app.isConnect);
      return this.$store.state.app.isConnect;
    },
    meetingRoomId() {
       return this.$store.state.app.meetingRoomId;
     },
  },
  methods: {
    //获取所属租户列表
    getCompanyList(callBack){
      this.$app
        .post("/tenant/list", {})
        .then((res) => {
        if (res.data.code == 0) {
          this.tenantList = res.data.data;
          let tenantId = localStorage.getItem("tenantId");
          if (tenantId) {
            this.choseValue = tenantId;
          } else{
            this.choseValue = this.tenantList[0].pkid;
          }
          let tenantObj = this.tenantList.filter((item) => item.pkid == this.choseValue);
          
          try {
            this.tenantName = tenantObj[0].name;
          } catch (error) {
            this.tenantName = this.tenantList[0].name;
            this.choseValue = this.tenantList[0].pkid;
          }

          if (callBack) {
            callBack();
          }
        }
      });
    },
    // 切换租户
    confirmTenant(){
      this.$app.post("/tenant/editCurrentTenant", {tenantId: this.choseValue}).then((res) => {
        if (res.data.code == 0) {
            localStorage.setItem("tenantId", res.data.data.pkid);
            this.tenantName = res.data.data.name;
            let that = this;
            this.$misc.findBoardRoomAll(this, (res) => {
              if (res.data.length == 0) {
                this.$store.commit("toggleReload",{vm:that,fn:()=>{
                  //如果是在终端切换会议室 也要刷新数据，强制将id改为0
                  if(that.$route.query.id){
                    that.$route.query.id = 0;
                  }
                }});
                that.$store.commit('setMeetingRoomList', res.data);
                return
              }
              let roomId = res.data[0].id;
              let roomNo = res.data[0].roomNo;

              that.$store.commit('setMeetingRoomList', res.data);

              //修改当前操作的会议室
              that.$misc.editCurrBoardRoom(that, roomId, roomNo, (res) => {
                if (res.code == 0) {
                  localStorage.setItem("currentMeetingId", "");
                  localStorage.setItem("currentRoom", JSON.stringify(res.data));
                  this.$store.commit("setMeetingRoomId", res.data.pkid);
                  this.$store.commit("setMeetingRoomNo", res.data.roomNo);
                  this.$store.commit("setMeetingRoomName", res.data.roomName);
                  //重新获取websocket地址
                  this.$misc.getSocketInfo(that, res => {
                      if(res.code == 0){
                        this.$store.commit("setServicePath", {address:res.data.wAddress,vm:this});
                      }
                      else{
                        this.$store.commit("setServicePath", {address:"",vm:this});
                      }
                      this.$store.commit("toggleReload",{vm:that,fn:()=>{
                        //如果是在终端切换会议室 也要刷新数据，强制将id改为0
                        if(that.$route.query.id){
                          that.$route.query.id = 0;
                        }
                      }});

                  });
                }
                else {
                  console.error("修改当前会议室失败");
                }

                this.tenantModal = false;
              });
            })
        } else{
          this.$Message.error(res.data.msg);
        }
      });
    },
    changeTenant(){
      this.getCompanyList((()=>{
        this.tenantModal = true;
      }));
    },
    init() {
      if (!this.isConnect) {
        this.$Message.destroy();
        this.$Message.error({
          content: "抱歉，连接失败，请检查网络或查看服务器是否开启，并刷新重试",
          duration: 10,
          closable: true,
        });
        this.$store.commit("changeConect", true);
      }
      let userType = sessionStorage.getItem("userType");
      if (userType != 1) {
        this.alertVisible = this.meetingRoomId == "undefined" || this.meetingRoomId == undefined ? true : false
      }
      let pathArr = util.setCurrentPath(this, this.$route.name);
      // this.$store.commit("updateMenulist");
      if (pathArr.length >= 2) {
        this.$store.commit("addOpenSubmenu", pathArr[1].name);
      }
      this.userName = Cookies.get("user");
      let messageCount = 3;
      this.messageCount = messageCount.toString();
      this.checkTag(this.$route.name);
      this.$store.commit("setMessageCount", 3);
    },
    toggleClick() {
      this.shrink = !this.shrink;
    },
    // 获取密级开关
    getEncryptLevelSwitch() {
      let tenantId = localStorage.getItem("tenantId");
      var param={}
      param.businessConfigList=[{ 
        businessId: tenantId, 
        configNos: [
          this.$store.state.configNos.tenantonfigNos.enable_meeting_secret_level,
        ] 
      }]
      this.$app.post("/config", param).then(res => {
          var businessConfigList=res.data.data.businessConfigList 
          if (res.data.code == 0 && businessConfigList.length>0) {
            businessConfigList.map((item)=>{
              console.log(item)
              switch (item.configNo) {
                // 密级是否开启
                case this.$store.state.configNos.tenantonfigNos.enable_meeting_secret_level:
                  this.$store.state.app.encryptLevelSwitch = item.configValue == 1;
                  break;
                default:
                  break;
              }
            })
          }
        })
    },
    handleClickUserDropdown(name) {
      if (name === "modPWD") {
        this.$refs.modPwd.showEditPassword();
      } else if (name === "loginout") {
        // 退出登录
        this.$store.commit("logout", this);
        this.$store.commit("clearOpenedSubmenu");
        // 关闭审核提示
        this.$Notice.close("auditTip");
        // 关闭电量不足提示
        this.$Notice.close("batteryTip");
        // 关闭所有提示
        this.$Notice.destroy();
        this.$router.push({
          name: "login",
        });
        //关闭websocket
        this.$_commSocket.close();
      }
    },
    checkTag(name) {
      let openpageHasTag = this.pageTagsList.some((item) => {
        if (item.name === name) {
          return true;
        }
      });
      if (!openpageHasTag) {
        //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
        util.openNewPage(
          this,
          name,
          this.$route.params || {},
          this.$route.query || {}
        );
      }
    },
    handleSubmenuChange(val) {
      // //console.log(val)
    },
    beforePush(name) {
      // if (name === 'accesstest_index') {
      //     return false;
      // } else {
      //     return true;
      // }
      return true;
    },
    fullscreenChange(isFullScreen) {
      // //console.log(isFullScreen);
    },
    scrollBarResize() {
      window.tableHeight = window.innerHeight - 325 + "";
      // 最小宽度小于1600px时，表格固定操作栏
      if (this.minTableWidth >= document.body.clientWidth) {
        window.isFixedOperate = true;
      } else{
        window.isFixedOperate = false;
      }
      //this.$refs.scrollBar.resize();
      if(window.outerWidth>1280){
        this.shrink=false;
      }
      else{
        this.shrink=true;
      }
    },
    // 无会议室访问权限退出登录
    ok(){
    // 退出登录
        this.$store.commit("logout", this);
        this.$store.commit("clearOpenedSubmenu");
        // 关闭审核提示
        this.$Notice.close("auditTip");
        this.$router.push({
          name: "login",
        });
    },
  },
  watch: {
    $route(to) {
      this.$store.commit("setCurrentPageName", to.name);
      let pathArr = util.setCurrentPath(this, to.name);
      if (pathArr.length > 2) {
        this.$store.commit("addOpenSubmenu", pathArr[1].name);
      }
      this.checkTag(to.name);
      localStorage.currentPageName = to.name;

      // 中控界面中隐藏头部，路径页
      /*if (to.name == "control-page") {
                this.controlPage = true;
            } else {
                this.controlPage = false;
            }*/
      // this.$store.dispatch("globalNotice",{title:"你跳转到了"+to.name+"页面",vm:this});
    },
    meetingRoomId(nval){
       let userType = sessionStorage.getItem("userType");
       if (userType != 1) {
         this.alertVisible = nval == "undefined" || nval == undefined ? true : false
       }
    },
    lang() {
      util.setCurrentPath(this, this.$route.name); // 在切换语言时用于刷新面包屑
    },
    openedSubmenuArr() {
      setTimeout(() => {
        this.scrollBarResize();
      }, 300);
    },
    isConnect(val) {
      if (!this.isConnect) {
        this.$Message.destroy();
        this.$Message.error({
          content: "抱歉，连接失败，请检查网络或查看服务器是否开启，并刷新重试",
          duration: 10,
          closable: true,
        });
        this.$store.commit("changeConect", true);
      }
    },
  },
  mounted() {
    this.init();
    // 根据浏览器窗体修改左侧菜单样式
    this.scrollBarResize();
    window.addEventListener("resize", this.scrollBarResize);

    // 超级管理员和三员可选择更换租户
    if (this.$_isXtAdmin() || this.$_isAdmin() || this.$_isBmAdmin() || this.$_isSjAdmin()) {
      this.isSuperManager = true;
      this.getCompanyList();
    }
  },
  created() {
    this.$store.dispatch("getUserImgUrl",{ vm: this })
    // 获取密级开关
    this.getEncryptLevelSwitch();
    
    this.$store.commit("setOpenedList");
    this.$store.dispatch("getMeetingRoomList", this);
    // this.$store.dispatch("getEnums",  { vm: this });
    this.$store.dispatch("getEnums", {
      vm:this,
      callBack: () => this.$store.dispatch("getUserModules", { vm: this })  // 显示打开的页面的列表
    });
    this.$store.dispatch("getSpecialCharacterConfig", { vm: this });

    var audioObj = document.createElement('audio');
    audioObj.src = '/static/alert.mp3';
    audioObj.addEventListener(
      'ended',
      function () {
        audioObj.pause();
      },
      false
    );
    this.$store.commit("setAudioObj", audioObj);
  },
  dispatch() {
    window.removeEventListener("resize", this.scrollBarResize);
  },
};
</script>
<style lang="less">
    .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal{
            top: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Main.vue